import axios from 'axios'
import Environments from '../environments/Environment';

var http = null;


class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.BASE_URL,
            headers: { 'Content-Type': 'application/json' },
        })
    }

    setSiacAltaCliente() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/siac/siac-alta-cliente')
            .then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else {
                    if (result.data.code == 8) {
                        localStorage.removeItem('session');
                        location.reload();
                    } else
                        error(result.data);
                }
            });
        });
    }

}

export default new APIProvider();


// WEBPACK FOOTER //
// ./src/services/siac.js